<mat-card style="border-color: #5775a8;">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <mat-icon style="color: white;">group</mat-icon>
      <span style="font-size: large; color: white;">
        User Administration
      </span>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div *ngIf="!editUser" class="flex flex-col w-full">
      <div class="flex flex-col">
        <br />
        <form [formGroup]="form">
          <div class="flex flex-row rounded-lg w-full">
            <div>
              <mat-form-field>
                <mat-label>Search Users</mat-label>
                <input matInput formControlName="searchText" placeholder="(blank search will show all users.)">
              </mat-form-field>
            </div>

            <div>
              <button mat-raised-button (click)="search()" class="m-8" style="background: #7ABDF3;">
                <mat-icon>search</mat-icon>
                Search
              </button>
            </div>

            <div class="flex flex-row rounded-lg w-full justify-end">
              <button mat-raised-button (click)="newUsers()" class="m-8">
                <mat-icon>add</mat-icon>
                New Users
              </button>
            </div>

          </div>
        </form>
      </div>

      <div *ngIf="!showSearchList" class="flex flex-col w-full">
        <div class="flex flex-col w-full" style="overflow-x:auto;">
          <div *ngIf="newUsersFlag">
            <span style="font-size: large;color: red;">New Users</span>
          </div>
          <div class="flex flex-row w-full">
            <div class="flex w-3/4">
            </div>
            <div class="flex flex-row w-1/2 rounded-lg justify-end">
              <input (keyup)="filterTable($event)" placeholder="Search" [value]="filter" />
            </div>
          </div>
          <div class="flex flex-row w-full">

            <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort" class="w-full">
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>User Name</th>
                <td mat-cell *matCellDef="let user"><a (click)="rowClick(user.userAndRole)">{{user.email}}</a>
                </td>
              </ng-container>
              <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
                <td mat-cell *matCellDef="let user">{{user.lastName}}
                </td>
              </ng-container>
              <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
                <td mat-cell *matCellDef="let user">{{user.firstName}}
                </td>
              </ng-container>
              <ng-container matColumnDef="enabled">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Enabled</th>
                <td mat-cell *matCellDef="let user" style="justify-content: center;">
                  <span *ngIf="user.enabled"><mat-icon style="color: green;">check</mat-icon></span>
                </td>
              </ng-container>
              <ng-container matColumnDef="fipsCountyId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>County</th>
                <td mat-cell *matCellDef="let user">
                  <ul>
                    <ng-container *ngFor="let countyId of countyListing(user.fipsCountyId)">
                      <li>{{county(countyId)}}</li>
                    </ng-container>
                  </ul>
                </td>
              </ng-container>
              <ng-container matColumnDef="roles">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Roles</th>
                <td mat-cell *matCellDef="let user">
                  <ul>
                    <ng-container *ngFor="let role of user.userAndRole.roles">
                      <li>{{role}}</li>
                    </ng-container>
                  </ul>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let user" style="justify-content: center; align-items: center;">
                  <a (click)="deleteUser(user.userAndRole)">
                  <mat-icon style="color: red;">delete</mat-icon>
                  </a>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
            </table>
          </div>
          <mat-paginator [pageSizeOptions]="[25, 100]" #TablePaginator="matPaginator"
            showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </div>

    <!-- Edit User -->

    <div *ngIf="editUser" class="flex flex-col w-full">
      <form [formGroup]="userForm">
        <div class="flex flex-col rounded-lg w-full justify-evenly">
          <mat-checkbox formControlName="enabled">
            <span>Enabled</span>
          </mat-checkbox>
          <div>
            <mat-form-field class="container">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email">
              <mat-error *ngIf="userForm.get('email').invalid">
                Field is required
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="container">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName">
              <mat-error *ngIf="userForm.get('firstName').invalid">
                Field is required
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="container">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName">
              <mat-error *ngIf="userForm.get('lastName').invalid">
                Field is required
              </mat-error>
            </mat-form-field>
          </div>
          <hr style="border: 1px solid gray;" />
          <div class="flex flex-col rounded-lg w-full">
            <span>Counties: </span>
            <mat-checkbox (change)="check('001', $event)" [checked]="countyChecked('001')">
              <span>Baker County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('003', $event)" [checked]="countyChecked('003')">
              <span>Benton County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('005', $event)" [checked]="countyChecked('005')">
              <span>Clackamas County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('007', $event)" [checked]="countyChecked('007')">
              <span>Clatsop County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('009', $event)" [checked]="countyChecked('009')">
              <span>Columbia County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('011', $event)" [checked]="countyChecked('011')">
              <span>Coos County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('013', $event)" [checked]="countyChecked('013')">
              <span>Crook County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('015', $event)" [checked]="countyChecked('015')">
              <span>Curry County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('017', $event)" [checked]="countyChecked('017')">
              <span>Deschutes County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('019', $event)" [checked]="countyChecked('019')">
              <span>Douglas County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('021', $event)" [checked]="countyChecked('021')">
              <span>Gilliam County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('023', $event)" [checked]="countyChecked('023')">
              <span>Grant County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('025', $event)" [checked]="countyChecked('025')">
              <span>Harney County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('027', $event)" [checked]="countyChecked('0027')">
              <span>Hood River County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('029', $event)" [checked]="countyChecked('029')">
              <span>Jackson County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('031', $event)" [checked]="countyChecked('031')">
              <span>Jefferson County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('033', $event)" [checked]="countyChecked('033')">
              <span>Josephine County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('035', $event)" [checked]="countyChecked('035')">
              <span>Klamath County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('037', $event)" [checked]="countyChecked('037')">
              <span>Lake County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('039', $event)" [checked]="countyChecked('039')">
              <span>Lane County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('041', $event)" [checked]="countyChecked('041')">
              <span>Lincoln County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('043', $event)" [checked]="countyChecked('043')">
              <span>Linn County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('045', $event)" [checked]="countyChecked('045')">
              <span>Malheur County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('047', $event)" [checked]="countyChecked('047')">
              <span>Marion County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('049', $event)" [checked]="countyChecked('049')">
              <span>Morrow County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('051', $event)" [checked]="countyChecked('051')">
              <span>Multnomah County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('053', $event)" [checked]="countyChecked('053')">
              <span>Polk County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('055', $event)" [checked]="countyChecked('055')">
              <span>Sherman County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('057', $event)" [checked]="countyChecked('057')">
              <span>Tillamook County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('059', $event)" [checked]="countyChecked('059')">
              <span>Umatilla County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('061', $event)" [checked]="countyChecked('061')">
              <span>Union County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('063', $event)" [checked]="countyChecked('063')">
              <span>Wallowa County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('065', $event)" [checked]="countyChecked('065')">
              <span>Wasco County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('067', $event)" [checked]="countyChecked('067')">
              <span>Washington County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('069', $event)" [checked]="countyChecked('069')">
              <span>Wheeler County</span>
            </mat-checkbox>
            <mat-checkbox (change)="check('071', $event)" [checked]="countyChecked('071')">
              <span>Yamhill County</span>
            </mat-checkbox>
          </div>
          <hr style="border: 1px solid gray;" />
          <div class="flex flex-col rounded-lg w-full">
            <span>Roles:</span>
            <mat-checkbox *ngFor="let role of rolesList" (change)="checkRole(role.name , $event)"
              [checked]="roleChecked(role.name)">
              <span>{{role.name}}</span>
            </mat-checkbox>
          </div>
          <hr style="border: 1px solid gray;" />
          <div class="flex flex-row rounded-lg w-full">
            <button mat-raised-button (click)="saveUser()" class="m-8" style="background: #7ABDF3;">
              <mat-icon>save</mat-icon>
              Save
            </button>
            <button mat-raised-button (click)="cancel()" class="m-8" style="padding-left: 20px;">
              <mat-icon>arrow_left</mat-icon>
              Return
            </button>
          </div>

        </div>

      </form>
    </div>

  </mat-card-content>
</mat-card>